module.exports = __webpack_public_path__ + "img/auburn-group.fa03899c.jpg";